import React from "react";
import { Box, Typography } from "@mui/material";

export default function VATPage() {
  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>
        VAT
      </Typography>
      <Typography>
        Coming soon: VAT return preparation and submission.
      </Typography>
    </Box>
  );
}
